/**
 * ChatBot (API)
 *  ChatBot関連のAPI
 */
import session from './session'
import file from './file'
import stream from './stream'

var uri = process.env.API_ENDPOINT

export default {
  saveScenario (data, companyid, scenarioName) {
    return session.post(uri + '/api/cb/save_scenario/' + companyid + '/' + scenarioName + '/', data)
  },
  getScenario (companyid, scenarioName) {
    return session.get(uri + '/api/cb/get_scenario/' + companyid + '/' + scenarioName + '/')
  },
  getScenarioDemo (type) {
    return session.get(uri + '/api/cb/get_scenario_demo/' + type + '/')
  },
  getScenarioOne (companyid, scenarioName, node, minipk) {
    if (!minipk) {
      return session.get(uri + '/api/cb/get_scenario_one/' + companyid + '/' + scenarioName + '/' + node + '/')
    } else {
      return session.get(uri + '/api/cb/get_scenario_one/' + companyid + '/' + scenarioName + '/' + node + '/' + minipk)
    }
  },
  getScenarioTemplate () {
    return session.get(uri + '/api/cb/get_scenario_template/')
  },
  importScenarioList (scenarioName, scenarioTable) {
    return session.put(uri + '/api/cb/create_scenario_list/'+ scenarioName + '/', scenarioTable)
  },
  cutdelScenarioTemplate (tempId, beforenode) {
    return session.delete(uri + '/api/cb/cutdel_scenario_template/' + tempId + '/' + beforenode + '/')
  },
  deleteScenarioTemplate (templateId) {
    return session.delete(uri + '/api/cb/delete_scenario_template/' + templateId + '/')
  },
  createScenarioList (scenarioName, scenarioTable) {
    return session.post(uri + '/api/cb/create_scenario_list/' + scenarioName + '/', scenarioTable)
  },
  deleteScenario (companyid, scenarioName, scenarioId) {
    return session.delete(uri + '/api/cb/delete_scenario/' + companyid + '/' + scenarioName + '/' + scenarioId + '/')
  },
  cutdelScenario (pk) {
    return session.delete(uri + '/api/cb/cutdel_scenario/' + pk + '/')
  },
  deleteScenarioList (companyid, scenarioName) {
    return session.delete(uri + '/api/cb/delete_scenario_list/' + companyid + '/' + scenarioName + '/')
  },
  saveScenarioList(scenarioTable, companyid, scenarioName) {
    return session.put(uri + '/api/cb/save_scenario_list/' + companyid + '/' + scenarioName + '/', scenarioTable)
  },
  updateScenario (scenario, companyid, scenarioName) {
    return session.put(uri + '/api/cb/update_scenario/' + companyid + '/' + scenarioName + '/' + scenario.pk + '/', scenario)
  },
  updateScenarioImage (data) {
    return file.put(uri + '/api/cb/update_scenario_image/', data)
  },
  updateScenarioName (scenario, companyid, scenarioName) {
    return session.put(uri + '/api/cb/update_scenario_name/' + companyid + '/' + scenarioName + '/' + scenario.pk + '/', scenario)
  },
  sortScenarioList (data) {
    return session.post(uri + '/api/cb/sort_scenario_list/', data)
  },
  saveScenarioEditLog (data) {
    return session.post(uri + '/api/cb/scenario_edit_log/', data)
  },
  getScenarioEditStats (data) {
    const req = Object.entries(data).map((item)=>{return item[0]+'='+item[1]}).join('&')
    return session.get(uri + '/api/cb/scenario_edit_stats?' + req)
  },
  scenarioPartsConfirm (data) {
    return session.put(uri + '/api/cb/scenario_parts_confirm/', data)
  },
  getRoboPartsSet () {
    return session.get(uri + '/api/cb/robo_parts_set/')
  },
  createRoboPartsSet (roboPartsSet) {
    return session.post(uri + '/api/cb/robo_parts_set/', roboPartsSet)
  },
  updateRoboPartsSet (roboPartsSet) {
    return session.put(uri + '/api/cb/robo_parts_set/', roboPartsSet)
  },
  deleteRoboPartsSet (roboPartsSetId) {
    return session.delete(uri + '/api/cb/robo_parts_set/' + roboPartsSetId + '/')
  },
  setRoboPartsSetInputFlg (flagData) {
    return session.post(uri + '/api/cb/robo_parts_set_input_flg/', flagData)
  },
  setRoboPartsSetOutputFlg (flagData) {
    return session.post(uri + '/api/cb/robo_parts_set_output_flg/', flagData)
  },
  getRoboPartsSetInput (roboPartsSetId) {
    return session.get(uri + '/api/cb/get_robo_parts_set_input/' + roboPartsSetId + '/')
  },
  exportRoboPartsSet (exportData) {
    return session.post(uri + '/api/cb/export_robo_parts_set/', exportData)
  },
  importRoboPartsSet (scenarioName, roboPartsSet) {
    return session.put(uri + '/api/cb/import_robo_parts_set/'+ scenarioName + '/', roboPartsSet)
  },
  getChatBot () {
    return session.get(uri + '/api/cb/get_chatbot/')
  },
  getChatBotOne (data) {
    return session.get(uri + '/api/cb/get_chatbot_one/' + data.companyid + '/' + data.scenario_name + '/')
  },
  getFromContentsChatBot (data) {
    return session.get(uri + '/api/cb/get_from_contents_chatbot/' + data.cid + '/' + data.ctsid + '/')
  },
  getChatBotRecommend (cid, botid) {
    return session.get(uri + '/api/cb/get_chatbot_recommend/' + cid + '/' + botid + '/')
  },
  getChatBotStatus (chatbotID) {
    return session.get(uri + '/api/cb/get_chatbot/status/' + chatbotID + '/')
  },
  createChatBot (data) {
    return session.post(uri + '/api/cb/create_chatbot/', data)
  },
  updateChatBot (chatbot, editIndex) {
    return session.put(uri + '/api/cb/update_chatbot/', chatbot)
  },
  updateChatBotsOrder (chatbots) {
    return session.put(uri + '/api/cb/update_chatbots/order/', chatbots)
  },
  updateChatBotIcon (name, id, image_id) {
    return session.put(uri + '/api/cb/update_chatbot_icon/', {name: name, bot_id: id, image_id:image_id})
  },
  reduceChatBot (data) {
    return session.put(uri + '/api/cb/reduce_chatbot/', data)
  },
  createChatBotQuestionnaire (data) {
    return session.post(uri + '/api/cb/create_chatbot_questionnaire/', data)
  },
  getScenarioName (companyid) {
    return session.get(uri + '/api/cb/get_scenario_name/' + companyid + '/')
  },
  deleteChatBot (companyid, chatbotID) {
    return session.delete(uri + '/api/cb/delete_chatbot/' + companyid + '/' + chatbotID + '/')
  },
  getChatBotStoreItem () {
    return session.get(uri + '/api/cb/get_chatbot_store_item/')
  },
  createChatBotStoreItem (bot) {
    return session.post(uri + '/api/cb/create_chatbot_store_item/', bot)
  },
  updateChatBotStoreItem (bot) {
    return session.post(uri + '/api/cb/update_chatbot_store_item/', bot)
  },
  deleteChatBotStoreItem (chatbotID) {
    return session.delete(uri + '/api/cb/delete_chatbot_store_item/' + chatbotID + '/')
  },
  installChatBot (bot) {
    return session.post(uri + '/api/cb/install_chatbot/', bot)
  },
  createChatBotStoreHistory (data) {
    return session.post(uri + '/api/cb/create_chatbot_store_history/', data)
  },
  createChatBotStoreRate (data) {
    return session.post(uri + '/api/cb/create_chatbot_store_rate/', data)
  },
  editChatBotStoreRate (data) {
    return session.put(uri + '/api/cb/edit_chatbot_store_rate/', data)
  },
  getChatBotStoreHistory () {
    return session.get(uri + '/api/cb/get_chatbot_store_history/')
  },
  getChatBotStoreRate () {
    return session.get(uri + '/api/cb/get_chatbot_store_rate/')
  },
  sendEmailScenario (data) {
    return session.post(uri + '/api/cb/send/email_scenario/', data)
  },
  sendSMSScenario (data) {
    return session.post(uri + '/api/cb/send/sms_scenario/', data)
  },
  getScenarioKPI (name) {
    return session.get(uri + '/api/cb/get_scenario_kpi/' + name + '/')
  },
  exportBot (company_id, id) {
    var w = window.open(uri + '/api/cb/get_scenario_excel/' + company_id + '/' + id + '/', '_blank')
    return false
  },
  importBot (file) {
    return session.post(uri + '/api/cb/post_scenario_excel/', file)
  },
  sendReminderEmail (id, param) {
    return session.post(uri + '/api/cb/send_reminder_email/' + id + '/', param)
  },
  uploadMovieFile (scenario, data, template_id) {
    return file.put(uri + '/api/cb/upload_movie_file/', {scenario: scenario, data: data, template_id: template_id})
  },
  uploadMovieFileCopy (scenario, data, template_id) {
    return file.put(uri + '/api/cb/upload_movie_file/', {scenario: scenario, movie_ref: data, template_id: template_id})
  },
  uploadAttachmentFile (scenario_pk, data) {
    return file.post(uri + '/api/cb/upload_scenario_attachment_file/', {scenario_pk: scenario_pk, data: data})
  },
  uploadAttachmentFileCopy (before_pk, after_pk) {
    return file.post(uri + '/api/cb/upload_scenario_attachment_file_copy/', {before_pk: before_pk, after_pk: after_pk})
  },
  getStory (id) {
    return session.get(uri + '/api/cb/story/' + id)
  },
  getPubStory (cid, id) {
    return session.get(uri + '/api/cb/pub_story' + '/' + cid + '/' + id)
  },
  createStory (data) {
    return session.post(uri + '/api/cb/story/', data)
  },
  readComment (data) {
    return session.patch(uri + '/api/cb/read_comment/', data)
  },
  updateStory (data) {
    return session.patch(uri + '/api/cb/story/', data)
  },
  deleteStory (id) {
    return session.delete(uri + '/api/cb/story/' + id)
  },
  getScene (id) {
    return session.get(uri + '/api/cb/scene/' + id)
  },
  createScene (data) {
    return session.post(uri + '/api/cb/scene/', data)
  },
  updateScene (data) {
    return session.patch(uri + '/api/cb/scene/', data)
  },
  deleteScene (id) {
    return session.delete(uri + '/api/cb/scene/' + id)
  },
  getCharacter (id) {
    return session.get(uri + '/api/cb/character/' + id)
  },
  createCharacter (data) {
    return session.post(uri + '/api/cb/character/', data)
  },
  updateCharacter (data) {
    return session.patch(uri + '/api/cb/character/', data)
  },
  deleteCharacter (id) {
    return session.delete(uri + '/api/cb/character/' + id)
  },
  getDialog (id) {
    return session.get(uri + '/api/cb/story_dialog/' + id)
  },
  createDialog (data) {
    return session.post(uri + '/api/cb/story_dialog/', data)
  },
  updateDialog (data) {
    return session.patch(uri + '/api/cb/story_dialog/', data)
  },
  deleteDialog (id) {
    return session.delete(uri + '/api/cb/story_dialog/' + id)
  },
  importStoryView (data) {
    return session.post(uri + '/api/cb/import_dialog/', data)
  },
  exportStoryView (id) {
    return session.get(uri + '/api/cb/export_dialog/' + id)
  },
  getNextPubStory (id) {
    return session.get(uri + '/api/cb/story_pub/' + id)
  },
  createPVStory (data) {
    return session.post(uri + '/api/cb/story_pv/', data)
  },
  createGVStory (data) {
    return session.post(uri + '/api/cb/story_gv/', data)
  },
  getPVStory (id) {
    return session.get(uri + '/api/cb/story_pv/' + id)
  },
  getGVStory (id) {
    return session.get(uri + '/api/cb/story_gv/' + id)
  },
  updatePVStory (data) {
    return session.patch(uri + '/api/cb/story_pv/', data)
  },
  updateGVStory (data) {
    return session.patch(uri + '/api/cb/story_gv/', data)
  },
  deletePVStory (id) {
    return session.delete(uri + '/api/cb/story_pv/' + id)
  },
  deleteGVStory (id) {
    return session.delete(uri + '/api/cb/story_gv/' + id)
  },
  copyStory (data) {
    return session.post(uri + '/api/cb/story_copy/', data)
  },
  pushDemo (data) {
    return session.post(uri + '/api/cb/push_demo/', data)
  },
  registerMovieDialog (data) {
    return session.patch(uri + '/api/cb/story_dialog/', data)
  },
  storyUserAction (data) {
    return session.post(uri + '/api/cb/story_user_action/', data)
  },
  getStoryUserAction (id) {
    return session.get(uri + '/api/cb/story_user_action/' + id)
  },
  replyEmail(data) {
    return session.post(uri + '/api/cb/reply_email/', data)
  },
  postStoryProfileFavorite (data) {
    return session.post(uri + '/api/cb/story_profile_favorite/', data)
  },
  getStoryProfileFavorite (id) {
    return session.get(uri + '/api/cb/get_story_profile_favorite/')
  },
  getStoryQuizAnswer (id) {
    if (id) return session.get(uri + '/api/cb/story_quiz_answer/' + id)
    else return session.get(uri + '/api/cb/story_quiz_answer/')
  },
  registerStoryQuizAnswer (data) {
    return session.post(uri + '/api/cb/story_quiz_answer/', data)
  },
  updateOrderChatbot(data) {
    return session.put(uri + '/api/cb/update_order_chatbot/', data)
  },
  updateOrderStory(data) {
    return session.put(uri + '/api/cb/update_order_story/', data)
  },
  // ChatBotMini API
  createChatBotMini (data) {
    return session.post(uri + '/api/cb/cbmini/', data)
  },
  getChatBotMini (id) {
    if (id) return session.get(uri + '/api/cb/cbmini/' + id)
    else return session.get(uri + '/api/cb/cbmini/')
  },
  updateChatBotMini (data) {
    return session.patch(uri + '/api/cb/cbmini/', data)
  },
  deleteChatBotMini (id) {
    return session.delete(uri + '/api/cb/cbmini/' + id)
  },
  // ChatBotMiniVariableGroup API
  createChatBotMiniVariableGroup (data) {
    return session.post(uri + '/api/cb/cbmini_varg/', data)
  },
  getChatBotMiniVariableGroup (id) {
    if (id) return session.get(uri + '/api/cb/cbmini_varg/' + id)
    else return session.get(uri + '/api/cb/cbmini_varg/')
  },
  updateChatBotMiniVariableGroup (data) {
    return session.patch(uri + '/api/cb/cbmini_varg/', data)
  },
  deleteChatBotMiniVariableGroup (pk) {
    return session.delete(uri + '/api/cb/cbmini_varg/' + pk)
  },
  // ChatBotHistory API
  createChatBotHistory (data) {
    return session.post(uri + '/api/cb/chatbot_history/', data)
  },
  getChatBotHistory (id) {
    if (id) return session.get(uri + '/api/cb/chatbot_history/' + id)
    else return session.get(uri + '/api/cb/chatbot_history/')
  },
  // ScenarioHistory API
  createScenarioHistoryAny (data) {
    return session.post(uri + '/api/cb/scenario_history_any/', data)
  },
  updateScenarioHistoryAny (data) {
    return session.patch(uri + '/api/cb/scenario_history_any/', data)
  },
  getScenarioHistory (id) {
    if (id) return session.get(uri + '/api/cb/scenario_history/' + id)
    else return session.get(uri + '/api/cb/scenario_history/')
  },
  // ChatBotUsedTimeHistory API
  createChatBotUsedTimeHistoryAny (data) {
    return session.post(uri + '/api/cb/chatbot_usedtime_history_any/', data)
  },
  getChatBotUsedTimeHistory (id) {
    if (id) return session.get(uri + '/api/cb/chatbot_usedtime_history/' + id)
    else return session.get(uri + '/api/cb/chatbot_usedtime_history/')
  },
  // ChatBotTag API
  createChatBotTag (data) {
    return session.post(uri + '/api/cb/chatbot_tag/', data)
  },
  getChatBotTag (id) {
    if (id) return session.get(uri + '/api/cb/chatbot_tag/' + id)
    else return session.get(uri + '/api/cb/chatbot_tag/')
  },
  updateChatBotTag (data) {
    return session.patch(uri + '/api/cb/chatbot_tag/' + data.pk, data)
  },
  deleteChatBotTag (id) {
    return session.delete(uri + '/api/cb/chatbot_tag/' + id)
  },
  exportChatBotTag () {
    return session.get(uri + '/api/cb/export_chatbot_tag/')
  },
  bulkCreateChatbotTag (data) {
    return session.post(uri + '/api/cb/bulk_chatbot_tag/', data)
  },
  getChatbotRegularSendingContent (bot_id, media_type) {
    return session.get(uri + '/api/cb/chatbot_regular_sending_content/' + bot_id + '/' + media_type)
  },
  setChatbotRegularSendingContent (data) {
    return session.patch(uri + '/api/cb/chatbot_regular_sending_content/', data)
  },
  chatBotRegularSendingPeriod (data) {
    return session.post(uri + '/api/cb/chatbot_regular_sending_period/', data)
  },
  fetchChatBotRegularSendingPeriod (bot_id, media_type) {
    return session.get(uri + '/api/cb/chatbot_regular_sending_period/' + bot_id + '?media_type=' + media_type)
  },
  deleteChatBotRegularSendingPeriod (bot_id, pk) {
    return session.delete(uri + '/api/cb/delete_chatbot_regular_sending_period/' + bot_id + '/' + pk)
  },
  chatBotRegularSending (data) {
    return session.post(uri + '/api/cb/chatbot_regular_sending/', data)
  },
  fetchChatBotRegularSending (bot_id, media_type) {
    return session.get(uri + '/api/cb/chatbot_regular_sending/' + bot_id + '?media_type=' + media_type)
  },
  deleteChatBotRegularSending (bot_id, pk) {
    return session.delete(uri + '/api/cb/chatbot_regular_sending/' + bot_id + '/' + pk)
  },
  updateChatBotRegularSending (bot_id, pk, data) {
    return session.patch(uri + '/api/cb/chatbot_regular_sending/' + bot_id + '/' + pk, data)
  },
  // SendScheduledMessage API
  createSendScheduledMessage (data) {
    return session.post(uri + '/api/cb/send_scheduled_message/', data)
  },
  getSendScheduledMessage (id, start_date, end_date) {
    return session.get(uri + '/api/cb/send_scheduled_message/' + id + '/' + start_date + '/' + end_date)
  },
  // メール送付
  sendEmailContent (data) {
    return session.post(uri + '/api/cb/send_email/', data)
  },
  // ロボの存在確認
  checkExistChatBot (data) {
    return session.get(uri + '/api/cb/check_exist_chatbot/' + data.cid + '/' + data.bid)
  },
  // ロボパフォーマンス情報の取得
  getChatBotPerformance (id, param) {
    const req = Object.entries(param).map((item)=>{return item[0]+'='+item[1]}).join('&')
    return session.get(uri + '/api/cb/get_chatbot_performance/' + id + '?' + req)
  },
  // ロボ詳細画面情報の取得
  getChatBotDetail (id) {
    return session.get(uri + '/api/cb/get_chatbot_detail/' + id)
  },
  // ロボ詳細画面情報の取得
  getChatBotStar (id) {
    return session.get(uri + '/api/cb/get_chatbot_star/' + id)
  },
  // ロボ詳細画面情報の取得
  getQuestionnaireData (id) {
    return session.get(uri + '/api/cb/get_questionnaire_data/' + id)
  },
  // PDFダウンロード
  PdfDownload (pdfData) {
    return stream.post(uri + '/api/cb/pdf_download/', pdfData)
  },
  exportChatBotMiniVariableGroup (data) {
    return session.post(uri + '/api/cb/export_chatbotmini_var/', data)
  },
  importChatBotMiniVariableGroup (data) {
    return session.post(uri + '/api/cb/import_chatbotmini_var/', data)
  },
  answerOutput (data) {
    return session.post(uri + '/api/cb/answer_output/', data)
  },
  getGoogleDriveFiles (user_id, folder_id) {
    return session.get(uri + '/api/cb/google_drive_get_list/' + user_id + '/' + folder_id)
  },
  createGoogleDriveFolder (data) {
    return session.post(uri + '/api/cb/google_drive_create_folder/', data)
  },
  deleteGoogleDriveFolder (data) {
    return session.get(uri + '/api/cb/google_drive_delete_folder/' + data.user_id + '/' + data.delete_folder_id)
  },
  getScenarioRecommend () {
    return session.get(uri + '/api/cb/scenario_recommend/')
  },
  getNextRobo (companyid) {
    return session.get(uri + '/api/cb/get_next_robo/' + companyid + '/')
  },
  UpdateScenarioStory (data, count) {
    return session.put(uri + '/api/cb/update_scenario_story/' + data + '/' + count)
  },
  UpdateStoryConfirm(name, data) {
    return session.put(uri + '/api/cb/update_story_confirm/' + name + '/' + data)
  },
  // 全テンプレートロボを取得
  getTemplateRobo () {
    return session.get(uri + '/api/cb/template_robo/')
  },
  // テンプレートロボのシナリオをコピーして新規ロボを作成
  copyTemplateRobo (roboInfo) {
    return session.post(uri + '/api/cb/copy_template_robo/', roboInfo)
  },
  // テンプレートからコピーして作成したロボとシナリオを削除
  deleteCopyRobo (scenario_name) {
    return session.delete(uri + '/api/cb/delete_copy_robo/' + scenario_name + '/')
  },
  // ロボ作成依頼送信
  roboCreateRequest (sendData) {
    return session.post(uri + '/api/cb/robo_create_request/', sendData)
  },
  // プルダウン値エクスポート
  exportPulldown (scenario_name,scenario_pk) {
    let w = window.open(uri + '/api/cb/get_pulldown_excel/' + scenario_name + '/' + scenario_pk + '/', '_blank')
    return false
  },
}



// WEBPACK FOOTER //
// ./src/api/chatbot.js